import '../../../styles/templates/proteus/main.scss';
import { initTransitions } from './transitions';
import { initNavigation } from './navigation';
import { initIcons } from './icons';

initTransitions();
initNavigation();
initIcons();

fetch(
  '/analytics/track_visit',
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      [document.querySelector('meta[name="csrf-param"]').content]: document.querySelector('meta[name="csrf-token"]').content,
      path: window.location.pathname + window.location.search,
    }),
  }
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js');
}

setTimeout(() => {
  document.body.style.opacity = '1';
}, 100);
